import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { FaqCategory } from '../types';

interface Props {
  category: FaqCategory;
  isChild: boolean;
  isExpanded?: boolean;
  isSubmitting: boolean;
  onToggleExpand?: () => void;
  onStartEdit: () => void;
  onDelete: () => void;
}

export const SortableCategoryItem: React.FC<Props> = ({
  category,
  isChild,
  isExpanded,
  isSubmitting,
  onToggleExpand,
  onStartEdit,
  onDelete,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: category.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <tr ref={setNodeRef} style={style} className={isChild ? 'bg-slate-50' : ''}>
      <td className="w-8 px-2 py-2">
        <button
          {...attributes}
          {...listeners}
          className="cursor-grab touch-none rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600 active:cursor-grabbing"
          title="ドラッグして並び替え"
        >
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z" />
          </svg>
        </button>
      </td>
      <td className="px-4 py-2 text-sm text-slate-900">
        {isChild && <span className="mr-2 text-slate-400">└</span>}
        {category.name}
      </td>
      <td className="px-4 py-2 text-center">
        <div className="flex items-center justify-center gap-2">
          {!isChild && onToggleExpand && (
            <button
              onClick={onToggleExpand}
              className="rounded px-2 py-1 text-xs font-medium text-slate-500 hover:bg-slate-100"
            >
              {isExpanded ? '閉じる' : '展開'}
            </button>
          )}
          <button
            onClick={onStartEdit}
            disabled={isSubmitting}
            className="rounded px-2 py-1 text-xs font-medium text-blue-600 hover:bg-blue-50 disabled:opacity-50"
          >
            編集
          </button>
          <button
            onClick={onDelete}
            disabled={isSubmitting}
            className="rounded px-2 py-1 text-xs font-medium text-red-600 hover:bg-red-50 disabled:opacity-50"
          >
            削除
          </button>
        </div>
      </td>
    </tr>
  );
};
